import type {AgentDropdownRepository} from '@github-ui/copilot-chat-types'

export const failedRepositoryLoad: AgentDropdownRepository[] = []
Object.freeze(failedRepositoryLoad)
